<template>
  <div class="container">
    <div class="action-button">
      <BbSkeletonLoader type="text" />
    </div>

    <div class="actions">
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
    </div>

    <div class="action-short">
      <BbSkeletonLoader type="text" />
    </div>

    <div class="image-wrapper">
      <BbSkeletonLoader type="image" />
    </div>

    <div class="actions">
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthoringSkeletonLoader',
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

@media (max-height: 750px) {
  .container {
    overflow: auto;
  }
}

.container {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);
  height: 80%;
  display: none;
  flex-direction: column;
  border: 1px solid $bb-neutral-4;
  background-color: $bb-neutral-0;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: center;
  min-width: 500px;
  max-width: 500px;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;

  .v-skeleton-loader {
    background: $bb-neutral-0 !important;

    :deep(.v-skeleton-loader__text) {
      background-color: $bb-neutral-5 !important;
    }

    // Kill Vuetify's default animated gradient sweep, keep the static bone shapes.
    :deep(.v-skeleton-loader__bone:after) {
      animation: none !important;
      background: none !important;
    }
  }

  .image-wrapper {
    width: 100%;
    min-height: 40%;
    margin-bottom: 12px;

    .v-skeleton-loader {
      height: 100%;

      :deep(.v-skeleton-loader__image) {
        height: 100%;
        background-color: $bb-neutral-5 !important;
        margin: $bb-spacing-1 $bb-spacing-4;
        border-radius: 6px;
      }
    }
  }

  .action-button {
    width: 65%;
    margin-right: auto !important;
    height: 58px;
    margin-top: 12px;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text) {
        height: 36px;
      }
    }
  }

  .actions {
    width: 100%;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text) {
        margin: $bb-spacing-1 $bb-spacing-4;
        border-radius: 4px;
        height: 28px;
      }
    }
  }

  .action-short {
    width: 40%;
    margin-right: auto;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text) {
        margin: $bb-spacing-1 $bb-spacing-4 $bb-spacing-4 $bb-spacing-4;
        border-radius: 4px;
        height: 28px;
      }
    }
  }
}
</style>
